import React from 'react';

const Header = () => {
  return (
    <header className="header-top">
      <div className="container">
        <div className="slogan-container">
          <a href="/internship" className="header-top-link">
            <div className="ticker-track">
              <span className="ticker-item"><strong>Now Enrolling</strong> — Hands-On Internship Program | Build Real Projects with 1-on-1 Mentorship → Apply Now</span>
              <span className="ticker-item"><strong>Now Enrolling</strong> — Hands-On Internship Program | Build Real Projects with 1-on-1 Mentorship → Apply Now</span>
            </div>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;